import { withProps } from 'react-recompose';
import Success from '../../components/SuccessPage/SuccessPage';
import theme from '../../config/themes/kaizen/index';
import { resetToDashboard } from '../../modules/Navigation/actions';
import I18n from '../../lib/i18n';

const withErrorProps = () => ({
  confirmButtonText: I18n.t('Dashboard.AddMoneyWithCreditCard.errorPage.buttonText'),
  successTitle: I18n.t('Dashboard.AddMoneyWithCreditCard.errorPage.renewalInProgress.body'),
  successImage: theme.failurePhoneImage,
  confirmButtonAction: resetToDashboard,
});

export default withProps(withErrorProps)(Success);
